import React from 'react';
import { useTranslation } from 'react-i18next';
import { ServicesSearchResults } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { FiltersProvider } from '@context';
import { useParams } from 'react-router';

export function ServicesSearchResultsPage() {
    const { searchQuery } = useParams();
    const { t } = useTranslation();

    const translations = {
        title: t('services-search-component.metatags.title'),
        description: t('services-search-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.servicesSearch.replace(':searchQuery', `${searchQuery}`),
        index: true,
    });

    return (
        <FiltersProvider>
            <ServicesSearchResults searchQuery={searchQuery || ''} />
        </FiltersProvider>
    );
}
